

module.exports = __webpack_require__.stylable.create(
    "ColorPicker2537454340",
    {"classes":{"root":"ColorPicker2537454340__root","wrapper":"ColorPicker2537454340__wrapper","item":"ColorPicker2537454340__item"},"vars":{},"stVars":{"ItemSize":"--overridable","BorderRadius":"--overridable","SelectionBorderColor":"--overridable"},"keyframes":{}},
    "",
    9,
    "ColorPicker2537454340",
    null
);
